import 'firebase/analytics';
import firebase from 'firebase/app';
import 'firebase/auth';

type AuthCredentials = {
  /** Email del formulario */
  emailInput: string;
  /** Contraseña del formulario */
  passwordInput: string;
};
type FirebaseUser = firebase.User;

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROYECTID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGINGID,
  appId: process.env.REACT_APP_APPID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

firebase.initializeApp(firebaseConfig);
firebase.analytics();

export const auth = firebase.auth();

export const signInUser = async (
  credentials: AuthCredentials
): Promise<void> => {
  try {
    const {emailInput, passwordInput} = credentials;
    await auth.signInWithEmailAndPassword(emailInput, passwordInput);
  } catch (error) {
    const errCode = (error as any).code; // FIXME: Any should not be used, but we need to fix this in the future. Now the business requires to move forward

    if (errCode === `auth/user-not-found`)
      throw new Error(
        `No hay un usuario asociado con esta cuenta ingresada, por favor intente de nuevo.`
      );

    if (errCode === `auth/invalid-email`)
      throw new Error(`La dirección de correo ingresada no es válida`);

    if (errCode === `auth/wrong-password`)
      throw new Error(
        `La contraseña ingresada no es válida, intente nuevamente`
      );

    if (errCode === `auth/too-many-request`)
      throw new Error(`Recargue la página y vuelva a intentarlo en 1 minuto`);

    throw new Error(
      `Ocurrió un error no identificado, intente nuevamente o lláme al proveedor del servicio si persiste`
    );
  }
};

export const signUpUser = async (
  credentials: AuthCredentials
): Promise<FirebaseUser> => {
  try {
    const {emailInput, passwordInput} = credentials;
    const authCredentials = await auth.createUserWithEmailAndPassword(
      emailInput,
      passwordInput
    );
    return authCredentials.user;
  } catch (err) {
    const errCode = (err as any).code;
    if (errCode === `auth/invalid-email`)
      throw new Error(`La dirección de correo ingresada no es válida`);

    throw new Error(
      `Error interno del servidor, porfavor intente mas tarde o llame al proveedor del servicio`
    );
  }
};

/**
 * Currently disabled
 */
export const resetPassword = (email: string) => {
  return auth.sendPasswordResetEmail(email, {
    url: `${process.env.REACT_APP_FRONTURL}`,
  });
};

export const signOut = async (): Promise<void | Error> => {
  try {
    await auth.signOut();
    localStorage.removeItem('idToken');
  } catch (ex) {
    throw new Error(ex as string);
  }
};
